<template>
  <div id="addReportTaskContainer">
      <form id="reportTaskForm">
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.reportTask.name')}}:</div>
                <input name="name" :placeholder="$t('Pm.placeholder.name')" v-model="pmGnbReportTask.name"
                    class="e-input e-input-group" maxlength="20" />
                <div class="error"></div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.reportTask.format')}}:</div>
                <ejs-dropdownlist :dataSource="formatList" v-model="pmGnbReportTask.format" name="format"
                    :fields="fieldsFormat" @change="formatChange" ></ejs-dropdownlist>
                <div class="error"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.reportTask.exeCycle')}}:</div>
                <ejs-dropdownlist :dataSource="exeCycleList" v-model="pmGnbReportTask.exeCycle" name="exeCycle"
                    :fields="fieldsFormat" @change="exeCycleChange" ></ejs-dropdownlist>
            </div>
            <div class="error"></div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox" >
          <div class="form-group">
            <div class="e-float-input" v-if="exeCycleFlag">
                <div class="h-inputLit">{{$t('Pm.reportTask.exeStep')}}:</div>
                <input name="exeStep" :placeholder="$t('Pm.placeholder.exeStep')"
                    v-model="pmGnbReportTask.exeStep" class="e-input e-input-group" maxlength="20" />
            </div>
            <div class="error"></div>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit">{{$t('Pm.reportTask.startTime')}}:</div>
                <ejs-datepicker :format="dateFormat" v-model="pmGnbReportTask.startTime" ref="startTime"
                    class="e-input" :allowEdit="false" @keydown.native="stopEvent" :locale="locale"></ejs-datepicker>
            </div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit">{{$t('Pm.reportTask.endTime')}}:</div>
                <ejs-datepicker :format="dateFormat" v-model="pmGnbReportTask.endTime" ref="endTime"
                    class="e-input" :allowEdit="false" :min="pmGnbReportTask.startTime" @keydown.native="stopEvent" :locale="locale"></ejs-datepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.reportTask.neType')}}:</div>
                <ejs-dropdownlist :dataSource="neTypeList" v-model="pmGnbReportTask.neType"
                    :fields="fieldsFormat"  name="neTypeCheck" @change="neTypeChange" ></ejs-dropdownlist>
            </div>
            <div class="error"></div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input" display="none">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.reportTask.parameterType')}}:</div>
                <ejs-dropdownlist :dataSource="parameterTypeList" v-model="pmGnbReportTask.parameterType"
                    :fields="fieldsFormat"  name="parameterTypeCheck" @change="parameterTypeChange" ></ejs-dropdownlist>
            </div>
            <div class="error"></div>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.reportTask.space')}}:</div>
                <ejs-dropdownlist :dataSource="spaceList" v-model="pmGnbReportTask.space"
                    :fields="fieldsFormat"  name="spaceCheck" @change="spaceChange" ></ejs-dropdownlist>
            </div>
            <div class="error"></div>
          </div>
        </div>
      </div>

      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input" id='customsBox'>
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.systemCounterList')}}:</div>
                <div v-for='(alarm, index) in systemCounterList' :key='index' class='col-sm-8 nopadding'>
                    <ejs-checkbox ref='systemCounterCheckbox' :label='alarm.text' :value='alarm.value' :checked='alarm.checked' name='systemCounterCheck'></ejs-checkbox>
                </div>
                <div class="error"></div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input" id='customCounterBox'>
              <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.customCounterList')}}:</div>
              <div v-for='(alarm, index) in customCounterList' :key='index' class='col-sm-8 nopadding'>
                <ejs-checkbox ref='customCounterCheckbox' :label='alarm.text' :value='alarm.value' :checked='alarm.checked' name='customCounterCheck'></ejs-checkbox>
              </div>
              <div class="error"></div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
    import { CheckBoxSelection } from '@syncfusion/ej2-vue-dropdowns';
    import { FormValidator } from "@syncfusion/ej2-vue-inputs";
    import mixin from '../../../../mixin/mixin';

    export default {
        name: 'AddReportTask',
        mixins: [mixin],
        displayFlag : 'none',
        props: {
            baseType: Number,
        },
        components: {
        },
        data() {
            return {
                formValidator: '',
                dateFormat: "yyyy-MM-dd",
                locale: localStorage.getItem('locale'),
                currentDay: new Date(),
                exeCycleFlag: false,
                neTypeList: [],
                parameterTypeList: [],
                spaceList: [],
                systemCounterList: [],
                customCounterList: [],
                neTypeCode: '',
                pmGnbReportTask: {
                    id: '',
                    name: '',
                    format: '',
                    exeCycle: '',
                    exeStep: '',
                    startTime: '',
                    endTime: '',
                    neType: '',
                    parameterType: '',
                    space: '',
                    counterList: '',
                    customCounterList: ''
                },
                customsCheckbox: [],
                fieldsFormat: {
                    text: "text",
                    value: "value"
                },
                exeCycleList: [
                    { text: `${this.$t('Pm.reportTask.hours')}`, value: 1 },
                    { text: `${this.$t('Pm.reportTask.days')}`, value: 2 },
                    { text: `${this.$t('Pm.reportTask.weeks')}`, value: 3 },
                    { text: `${this.$t('Pm.reportTask.months')}`, value: 4 },
                    { text: `${this.$t('Pm.reportTask.fixedDays')}`, value: 5 }
                ],
                formatList: [
                    { text: "csv", value: "csv" },
                    { text: "excel", value: "excel" },
                ],
                validateOptions: {
                    customPlacement: function(inputElement, errorElement) {
                        inputElement = inputElement.closest('.form-group').querySelector('.error');
                        inputElement.parentElement.appendChild(errorElement);
                    },
                    rules: {
                        'name': {
                            required: [true, `${this.$t('Pm.placeholder.name')}`],
                            maxLength: [20, `${this.$t('Common.maxLength')}`.replace('{0}', 20)]
                        },
                        'format': {
                            required: [true, `${this.$t('Pm.placeholder.format')}`],
                        },
                        'exeCycle': {
                            required: [true, `${this.$t('Pm.placeholder.exeCycle')}`],
                        },
                        'exeStep': {
                            regex: ['^\\d*$',`${this.$t('Topo.invalidInt')}`],
                        },
                        'neTypeCheck': {
                            required: [true, `${this.$t('Pm.placeholder.neType')}`],
                        },
                        'parameterTypeCheck': {
                            required: [true, `${this.$t('Pm.placeholder.parameterType')}`],
                        },
                        'spaceCheck': {
                            required: [true, `${this.$t('Pm.placeholder.space')}`],
                        },
                        'systemCounterCheck': {
                            required: [true, `${this.$t('Pm.systemCounterList')}`],
                        },
                        'customCounterCheck': {
                            required: [true, `${this.$t('Pm.customCounterList')}`],
                        },
                    }
                }
            }
        },
        methods: {
            init(){
                this.getNeTypes();
                this.formValidator = new FormValidator('#reportTaskForm', this.validateOptions);
            },
            exeCycleChange(msg) {
                this.pmGnbReportTask.exeCycle = msg.value;
                if(msg.value == '5'){
                    this.exeCycleFlag = true;
                }else{
                    this.exeCycleFlag = false;
                }
            },
            formatChange(msg) {
                this.pmGnbReportTask.format = msg.value;
            },
            getNeTypes() {
                this.$axios.get("/lte/ems/pm/gnb/report/task/findNeTypes").then(response => {
                    const resultVal = response.data.resultVal;
                    for (let i = 0; i < resultVal.length; i++) {
                        this.neTypeList.push({
                            text: resultVal[i].neTypeNam + '-' + resultVal[i].protocolVersion,
                            value: resultVal[i].neTypeCode + '-' + resultVal[i].protocolVersion,
                        });
                    }
                });
            },
            neTypeChange(msg){
                this.pmGnbReportTask.neType = msg.value;
                const params = { params: {
                    neTypeCode: this.pmGnbReportTask.neType.split('-')[0],
                }};
                this.$axios.get("/lte/ems/pm/gnb/report/task/findParameterTypes", params).then(response => {
                    const resultVal = response.data.resultVal;
                    this.parameterTypeList = [];
                    for (let i = 0; i < resultVal.length; i++) {
                        this.parameterTypeList.push({
                            text: resultVal[i].paramTypeName,
                            value: resultVal[i].paramTypeCode + '-' + resultVal[i].paramTypeName,
                        });
                    }
                });
            },
            parameterTypeChange(msg){
                if(this.pmGnbReportTask.neType == null || this.pmGnbReportTask.neType == ''){
                    return;
                }
                this.pmGnbReportTask.parameterType = msg.value;
                const params = { params: {
                    parameterCode: this.pmGnbReportTask.parameterType.split('-')[0],
                }};
                this.$axios.get("/lte/ems/pm/gnb/report/task/findSpaces", params).then(response => {
                    const resultVal = response.data.resultVal;
                    this.spaceList = [];
                    for (let i = 0; i < resultVal.length; i++) {
                        this.spaceList.push({
                            text: resultVal[i].spaceName,
                            value: resultVal[i].spaceCode + '-' + resultVal[i].spaceName,
                        });
                    }
                });
            },
            spaceChange(msg){
                if(this.pmGnbReportTask.neType == null || this.pmGnbReportTask.neType == ''){
                    return;
                }
                if(this.pmGnbReportTask.parameterType == null || this.pmGnbReportTask.parameterType == ''){
                    return;
                }
                this.pmGnbReportTask.space = msg.value;
                const params = { params: {
                    parameterType: this.pmGnbReportTask.parameterType.split('-')[0],
                    space: this.pmGnbReportTask.space.split('-')[0],
                }};
                this.$axios.get("/lte/ems/pm/gnb/report/task/getCountets", params).then(response => {
                    const resultVal = response.data.resultVal;
                    this.systemCounterList = [];
                    for (let i = 0; i < resultVal.length; i++) {
                        this.systemCounterList.push({
                            text: resultVal[i].counterNameCH,
                            value: resultVal[i].counterNameEN + '-' + resultVal[i].counterNameCH,
                        });
                    }
                });

              this.$axios.get("/lte/ems/pm/gnb/report/task/getCustomCounters", params).then(response => {
                const resultVal = response.data.resultVal;
                this.customCounterList = [];
                for (let i = 0; i < resultVal.length; i++) {
                  this.customCounterList.push({
                    text: resultVal[i].counterNameCH,
                    value: resultVal[i].counterCode + '-' + resultVal[i].counterNameCH,
                  });
                }
              });
            },
            getReportTask() {
              const systemCounterCheckbox = this.getArray('customsBox');
              const customCounterCheckbox = this.getArray('customCounterBox');
              const mapDateSystemCounter = new Map();
              const mapDateCustomCounter = new Map();
              for (var i = 0; i < systemCounterCheckbox.length; i++) {
                var data = systemCounterCheckbox[i];
                mapDateSystemCounter.set(data.split("-")[0], data.split("-")[1]);
              }
              for (var i = 0; i < customCounterCheckbox.length; i++) {
                var data = customCounterCheckbox[i];
                mapDateCustomCounter.set(data.split("-")[0], data.split("-")[1]);
              }
              const jsonDateSystemCounter = JSON.stringify(this.strMapToObj(mapDateSystemCounter));
              const jsonDateCustomCounter = JSON.stringify(this.strMapToObj(mapDateCustomCounter));
              return {
                  name: this.pmGnbReportTask.name,
                  format: this.pmGnbReportTask.format,
                  exeCycle: this.pmGnbReportTask.exeCycle,
                  exeStep: this.pmGnbReportTask.exeStep,
                  startTime: (new Date(this.pmGnbReportTask.startTime)).getTime(),
                  endTime: (new Date(this.pmGnbReportTask.endTime)).getTime(),
                  neType: this.pmGnbReportTask.neType,
                  parameterType: this.pmGnbReportTask.parameterType,
                  space: this.pmGnbReportTask.space,
                  counterList: jsonDateSystemCounter,
                  customCounterList: jsonDateCustomCounter
               }
            },
            getArray(id) {
                const checkedDom = document.querySelectorAll(`#${id} [aria-checked=true] input`);
                const array = [];
                for (let i = 0; i < checkedDom.length; i++) {
                    array.push(checkedDom[i].value);
                }
                return array;
            },
            validation() {
                try{
                    status = this.formValidator.validate();
                    return status;
                }catch(e) {

                }
                return true;
            },
            stopEvent(event) {
                if (event.keyCode == 13) {
                    event.cancelBubble = true;
                    event.returnValue = false;
                    return false;
                }
            }
        }
    };
</script>
